/**
 * Reconnaissance du format de persistance de Strategy et State.
 *
 * La conversion elle-même est faite côté serveur (`functions/src/migration/`) : c'est là
 * que vit la correspondance entre l'ancien format et le nouveau. Ce module ne garde que
 * la version de schéma et la détection, dont le client a besoin pour estampiller les
 * documents qu'il lit et savoir s'ils sont à jour.
 *
 * Dupliquer ici la table de correspondance ferait vivre deux copies d'une même règle, avec
 * le risque qu'elles divergent.
 */

/**
 * Version du schéma de persistance de Strategy et State.
 *  - 1 (implicite, `schemaVersion` absent) : tous les domaines imbriqués dans le document parent.
 *  - 2 : document parent allégé + un document par domaine dans une collection sœur.
 */
export const SCHEMA_VERSION = 2

/** Champs de domaine portés par un document Strategy de l'ancienne architecture. */
const LEGACY_STRATEGY_FIELDS = [
  'buildings', 'tools', 'stuffs', 'staff', 'trainings',
  'offers', 'contracts', 'communications', 'loans', 'supplier',
  'bank', // champ historique jamais exploité, supprimé à la conversion
]

/** Champs racine portés par un document State de l'ancienne architecture. */
const LEGACY_STATE_FIELDS = ['data', 'scores', 'results']

function hasOwn(data, key) {
  return data !== null && data !== undefined && Object.prototype.hasOwnProperty.call(data, key)
}

/**
 * Détecte un document Strategy de l'ancienne architecture.
 * Un document déjà estampillé `schemaVersion >= 2` n'est jamais reconverti. La détection
 * s'appuie sur la présence effective d'un champ de domaine historique, et non sur la seule
 * absence de `schemaVersion`, pour éviter les faux positifs.
 */
export function isLegacyStrategyData(data) {
  if (!data) return false
  if (Number(data.schemaVersion) >= SCHEMA_VERSION) return false
  return LEGACY_STRATEGY_FIELDS.some(field => hasOwn(data, field))
}

/** Détecte un document State de l'ancienne architecture. */
export function isLegacyStateData(data) {
  if (!data) return false
  if (Number(data.schemaVersion) >= SCHEMA_VERSION) return false
  return LEGACY_STATE_FIELDS.some(field => hasOwn(data, field))
}
